import React from "react";
import SubmitButton from "../Button/SubmitButton";
import CancelButton from "../Button/CancelButton";
import Form from "./Form";
import { FormProps } from "../../@types/";

const DeleteForm = (props: FormProps) => {
  return (
    <>
      <Form
        title={props.title}
        description={props.description}
        cancelButton={<CancelButton onClick={props.onCancel} />}
        submitButton={<SubmitButton onClick={props.onSubmit} />}
      />
    </>
  );
};

export default DeleteForm;
